// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_25-2";
export var blackBorderOnHover = "_25-7";
export var cell = "_25-6";
export var cellContainer = "_25-3";
export var checked = "_25-8";
export var disabled = "_25-5";
export var featuredIconCellContainer = "_25-9";
export var featuredIconTextContainer = "_25-b";
export var featuredIconWrapper = "_25-a";
export var noBorder = "_25-c";
export var orangeSelectedRow = "_54-3";
export var overflowableText = "_25-0";
export var overflowableTextContainer = "_25-1";
export var row = "_1o-0";
export var rowCheckboxCell = "_25-4";
export var selectableTable = "_54-2";